/**
 * @file 資料のページの対応 (ページ → 別の資料のページ) のクライアント。
 * @what: `GET /families/{familyId}/study/sources/{sourceId}/page-links`。対応が無い資料では空配列を返す。
 * @why: リーダーの「関係するページ」は、この資料の対応と、相手側から逆向きに引いた対応を並べる
 *   (model/pageLinks.ts)。本だなの一覧に埋めると重いので、資料を開いたときだけ取る。
 * @failure: ApiError を伝播する。空配列は対応を取り込んでいない状態で、正常系である。
 */

import { apiFetch } from "@/shared/api/client";

export interface StudySourcePageLink {
  /** この資料のページ (連番)。 */
  page: number;
  /** 相手の資料 id。 */
  target: string;
  /** 相手の資料のページ (連番)。 */
  target_page: number;
}

export async function fetchSourcePageLinks(
  familyId: string,
  sourceId: string,
  signal?: AbortSignal,
): Promise<StudySourcePageLink[]> {
  const res = await apiFetch<{ entries: StudySourcePageLink[] }>(
    `/families/${encodeURIComponent(familyId)}/study/sources/${encodeURIComponent(sourceId)}/page-links`,
    signal ? { signal } : {},
  );
  return res.entries;
}
